<div class="chart-container">
  @if (seriesData().length > 0) {
    <canvas baseChart
            [data]="chartData()"
            [options]="chartOptions()"
            [type]="'line'">
    </canvas>
  } @else {
    <div class="empty-state">
      <p>データがありません</p>
    </div>
  }
</div>
